import { ActivityIndicator, StyleSheet, TouchableOpacity, View } from "react-native";
import React, { memo, useState } from "react";
import Svg, { Circle, Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { router, useLocalSearchParams } from "expo-router";
import { setCart, updateCartProduct } from "appRedux/reducers/cartSlice";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { Colors } from "colors";
import ImageView from "../../../src/image";

import SaleComponent from "components/PLP/SaleComponent";
import StepperButton from "components/PDP/StepperButton";
import VText from "components/VText";
import { getFormatedCurrency } from "utils/common";
import { trackV2 } from "utils/Segment";

const MAX_CART_QTY = 10;

const CheckoutPopUpCard = ({
    cartItem = {},
    hideOptions = false,
    containerStyle = {},
    hideCross = false,
    idx = 0,
    isInPopUp = false,
    sizeTextStyle = {},
    gender = "",
}) => {
    const [removeLoading, setRemoveLoading] = useState(false);
    const [chnageQtyLoading, setChnageQtyLoading] = useState(false);
    const dispatch = useDispatch();
    const countrySymbol = useSelector((state) => state.StoredutilsSlice.countrySymbol);
    const cart = useSelector((state) => state.CartReducer.cart);

    const removeFromCart = () => {
        if (removeLoading || chnageQtyLoading) {
            return;
        }
        const eventData = {
            product_id: cartItem?.product?.id,
            product_name: cartItem?.product?.productName,
            total_cart_value: cart?.orderSummary?.totalAmount,
        };
        trackV2(ANALYTICS_EVENT_NAMES.PRODUCT_REMOVED, eventData);
        setRemoveLoading(true);
        dispatch(
            updateCartProduct({
                productId: cartItem?.product?.id,
                quantity: 0,
            })
        )
            .then((res) => {
                setRemoveLoading(false);
                if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
                    dispatch(setCart(res?.payload?.data));
                }
            })
            .catch((err) => {
                setRemoveLoading(false);
                console.log("err", err);
            });
    };

    const onPressMinusBtn = () => {
        if (removeLoading || chnageQtyLoading) {
            return;
        }
        const eventData = {
            product_id: cartItem?.product?.id,
            product_name: cartItem?.product?.productName,
            new_quantity: cartItem?.quantity - 1,
            old_quantity: cartItem?.quantity,
            total_cart_value: cart?.orderSummary?.totalAmount,
        };
        alert(JSON.stringify(eventData));
        trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);
        setChnageQtyLoading(true);
        dispatch(
            updateCartProduct({
                productId: cartItem?.product?.id,
                quantity: cartItem?.quantity - 1,
                size: cartItem?.productSize,
            })
        )
            .then((res) => {
                setChnageQtyLoading(false);
                if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
                    dispatch(setCart(res?.payload?.data));
                }
            })
            .catch((err) => {
                setChnageQtyLoading(false);
            });
    };

    const onPressPlusBtn = () => {
        if (cartItem?.quantity == MAX_CART_QTY) {
            return;
        }
        if (removeLoading || chnageQtyLoading) {
            return;
        }
        const eventData = {
            product_id: cartItem?.product?.id,
            product_name: cartItem?.product?.productName,
            new_quantity: cartItem?.quantity + 1,
            old_quantity: cartItem?.quantity,
            total_cart_value: cart?.orderSummary?.totalAmount,
        };
        trackV2(ANALYTICS_EVENT_NAMES.QUANTITY_UPDATED, eventData);
        setChnageQtyLoading(true);
        dispatch(
            updateCartProduct({
                productId: cartItem?.product?.id,
                quantity: cartItem?.quantity + 1,
                size: cartItem?.productSize,
            })
        )
            .then((res) => {
                setChnageQtyLoading(false);
                if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
                    dispatch(setCart(res?.payload?.data));
                }
            })
            .catch((err) => {
                setChnageQtyLoading(false);
            });
    };

    return (
        <View
            style={{
                zIndex: (idx + 1) * -10,
                flex: 1,
            }}
        >
            <View
                style={[
                    {
                        marginBottom: hideOptions ? 0 : spV(28),
                        backgroundColor: "white",
                        zIndex: -100,
                    },
                ]}
            >
                <View
                    style={[
                        {
                            flexDirection: "row",
                            zIndex: -100,
                        },
                        containerStyle,
                    ]}
                >
                    <TouchableOpacity
                        activeOpacity={0.8}
                        onPress={() => {
                            router.push(
                                `/product?id=${cartItem?.product?.id}&brand=${cartItem?.product?.brandName}&product=${cartItem?.product?.productName}&gender=${gender}`
                            );
                        }}
                    >
                        <ImageView
                            style={{
                                width: wp(88.8),
                                marginRight: spH(16),
                                height: hp(118.4),
                            }}
                            resizeMode={ImageView.resizeMode.contain}
                            source={{ uri: cartItem?.product?.imageUrls?.[0] }}
                        />
                    </TouchableOpacity>
                    <View
                        style={{
                            marginRight: spH(36),
                            flex: 1,
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(12),
                                lineHeight: "140%",
                                fontWeight: "550",
                                marginBottom: spV(4),
                            }}
                            text={cartItem?.product?.brandName?.toUpperCase()}
                        />
                        <VText
                            style={{
                                fontSize: fp(12),
                                lineHeight: "140%",
                                fontWeight: "350",
                                marginBottom: spV(4),
                                width: "100%",
                            }}
                            numberOfLines={2}
                            text={cartItem?.product?.productName}
                        />
                        {!cartItem?.isAvailable && (
                            <VText
                                style={{
                                    fontSize: fp(12),
                                    lineHeight: fp(14),
                                    fontWeight: "350",
                                    marginVertical: spV(4),
                                    color: "#FF0000",
                                }}
                                text={"OUT OF STOCK"}
                            />
                        )}
                        {cartItem?.product?.salePercentage && cartItem?.product?.salePercentage > 0 ? (
                            <SaleComponent
                                originalPrice={cartItem?.product?.originalProductPrice}
                                finalPrice={cartItem?.product?.productPrice}
                                discountPercentage={cartItem?.product?.salePercentage}
                            />
                        ) : (
                            <VText
                                text={`${countrySymbol}${getFormatedCurrency(cartItem?.product?.productPrice)}`}
                                style={{
                                    fontSize: fp(12),
                                    lineHeight: "140%",
                                    fontWeight: "550",
                                    marginBottom: spH(8),
                                }}
                            />
                        )}
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                width: "100%",
                                flex: 1,
                            }}
                        >
                            <View style={sizeTextStyle}>
                                <VText
                                    style={[
                                        {
                                            fontSize: fp(12),
                                            lineHeight: "140%",
                                            fontWeight: "350",
                                        },
                                    ]}
                                    text={`Size: ${cartItem?.productSize}`}
                                />
                            </View>
                        </View>
                        {hideOptions && (
                            <VText
                                style={{
                                    fontSize: fp(12),
                                    lineHeight: "140%",
                                    fontWeight: "350",
                                    paddingTop: spH(6),
                                }}
                                text={`Quantity: ${cartItem?.quantity}`}
                            />
                        )}
                        {!hideOptions && isInPopUp && (
                            <StepperButton
                                itemCount={cartItem?.quantity}
                                onPressMinusBtn={() => onPressMinusBtn()}
                                onPressPlusBtn={() => onPressPlusBtn()}
                                customStyle={{
                                    height: hp(24),
                                    width: wp(60),
                                    minWidth: wp(60),
                                    marginTop: 4,
                                }}
                                btnContainerstyle={{
                                    paddingHorizontal: 4,
                                }}
                                countStyle={{
                                    fontSize: fp(12),
                                }}
                                svgIconsSize={12}
                                MAX_CART_QTY={MAX_CART_QTY}
                                loading={chnageQtyLoading}
                            />
                        )}
                    </View>
                    {!hideCross && (
                        <TouchableOpacity
                            style={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                            }}
                            activeOpacity={0.8}
                            onPress={() => removeFromCart()}
                        >
                            {!removeLoading && (
                                <Svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <Circle cx="10" cy="10" r="10" fill="#F7F7F7" />
                                    <Path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.46941 9.99974L6.41992 13.0492L6.95025 13.5796L9.99974 10.5301L13.0492 13.5796L13.5796 13.0492L10.5301 9.99974L13.5796 6.95025L13.0492 6.41992L9.99974 9.46941L6.95026 6.41992L6.41993 6.95025L9.46941 9.99974Z"
                                        fill="#212427"
                                    />
                                </Svg>
                            )}
                            {removeLoading && <ActivityIndicator />}
                        </TouchableOpacity>
                    )}
                </View>
            </View>
        </View>
    );
};

export default memo(CheckoutPopUpCard);
